import cn from 'classnames';
import {PaymentMethodType} from '../../lendtech/components/Lendtechpaysheet/LendTechPaySheetTypes';

interface IProps {
  title: string;
  description: string;
  value: PaymentMethodType;
  checked: boolean;
  onChange: (value: PaymentMethodType) => void;
  disabled?: boolean;
  className?: string;
}

const PaymentRow = ({
  title,
  description,
  value,
  checked,
  onChange,
  disabled,
  className,
}: IProps) => {
  return (
    <label
      className={cn(
        'flex items-start gap-2.5',
        className,
        disabled && 'opacity-40 pointer-events-none',
      )}
    >
      <input
        type="radio"
        name="payment_type"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        className="scale-125 translate-y-1 accent-farm-shop-500"
      />

      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">{title}</span>
        <span className="text-sm text-gray-500">{description}</span>
      </div>
    </label>
  );
};

export default PaymentRow;
